/* promise/lib/done */ function _(require, module, exports) {
    var Promise = require(278) /* ./core.js */;
    module.exports = Promise;
    Promise.prototype.done = function (onFulfilled, onRejected) {
        var self = arguments.length ? this.then.apply(this, arguments) : this;
        self.then(null, function (err) {
            setTimeout(function () {
                throw err;
            }, 0);
        });
    };
}
